<template>
    <div class="glowing-video">
      <a 
        v-if="isPostal2" 
        href="https://www.instagram.com/hampnyc" 
        target="_blank" 
        class="caption-link"
      >
        Directed by @hampnyc
      </a>
      
      <!-- Blurred background video -->
      <video 
        class="glow" 
        :src="src" 
        :style="glowStyle" 
        :autoplay="autoplay"
        :muted="muted"
        :loop="loop"
        :playsinline="playsinline"
        ref="glowVideo"
      ></video>
      <!-- Foreground (main) video -->
      <video 
        class="main" 
        :src="src" 
        :autoplay="autoplay"
        :muted="muted"
        :loop="loop"
        :playsinline="playsinline"
        ref="mainVideo"
        @play="syncVideos"
        @seeking="syncVideos"
        @click="openVideoSource"
        style="cursor: pointer"
      ></video>

      <!-- Unmute button -->
      <button 
      class="unmute-button" 
      @click="toggleMute" 
      :title="isMuted ? 'Unmute' : 'Mute'"
      v-if="!isTowerCity"
    >
      <span v-if="isMuted">
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.7">
          <path d="M5 5H1.66667C1.29848 5 1 5.29848 1 5.66667V12.3333C1 12.7015 1.29848 13 1.66667 13H5M5 5L10.657 1.6058C11.1014 1.33919 11.6667 1.65926 11.6667 2.17746V15.8225C11.6667 16.3407 11.1014 16.6608 10.657 16.3942L5 13M5 5V13" stroke="white" stroke-width="2"/>
          <path d="M15.6641 6.32812L20.9974 11.6615" stroke="white" stroke-width="2" stroke-linecap="round"/>
          <path d="M15.6641 11.6641L20.9974 6.33073" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </g>
        </svg>
      </span>
      <span v-else>
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.7">
          <path d="M5 5H1.66667C1.29848 5 1 5.29848 1 5.66667V12.3333C1 12.7015 1.29848 13 1.66667 13H5M5 5L10.657 1.6058C11.1014 1.33919 11.6667 1.65926 11.6667 2.17746V15.8225C11.6667 16.3407 11.1014 16.6608 10.657 16.3942L5 13M5 5V13" stroke="white" stroke-width="2"/>
          <path d="M15 6.17188C15.7239 6.89573 16.1716 7.89573 16.1716 9.0003C16.1716 10.1049 15.7239 11.1049 15 11.8287" stroke="white" stroke-width="2" stroke-linecap="round"/>
          <path d="M18.125 4.04688C19.3918 5.31363 20.1753 7.06363 20.1753 8.99662C20.1753 10.9296 19.3918 12.6796 18.125 13.9464" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </g>
        </svg>
      </span>
    </button>
    </div>
  </template>
  
  <script>
  export default {
    name: "VideoGlow",
    props: {
      src: { type: String, required: true },
      blur: { type: Number, default: 8 },
      opacity: { type: Number, default: 1 },
      autoplay: { type: Boolean, default: true },
      muted: { type: Boolean, default: true },
      loop: { type: Boolean, default: true },
      playsinline: { type: Boolean, default: true }
    },
    data() {
      return {
        isMuted: true
      };
    },
    created() {
        this.isMuted = this.muted;
    },
    computed: {
      glowStyle() {
        return {
          filter: `blur(${this.blur}px)`,
          opacity: this.opacity
        };
      },
      isPostal2() {
        return this.src.includes("postal-2");
      },
      isTowerCity() {
        return this.src.includes("tower city");
      }
    },
    methods: {
      syncVideos() {
        // Keep the glow video in sync with the main video
        const mainVideo = this.$refs.mainVideo;
        const glowVideo = this.$refs.glowVideo;
        if (mainVideo && glowVideo) {
          glowVideo.currentTime = mainVideo.currentTime;
        }
      },
      toggleMute() {
        this.isMuted = !this.isMuted;
        // Sync mute state between both videos
        if (this.$refs.mainVideo) this.$refs.mainVideo.muted = this.isMuted;
        // if (this.$refs.glowVideo) this.$refs.glowVideo.muted = this.isMuted;
      },
      openVideoSource() {
        window.open(this.src, '_blank');
      }
    }
  };
  </script>
  
  <style scoped>
  .glowing-video {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  
  .glowing-video video {
    display: block;
    width: 100%;
    height: 100%;
  }
  
  .glowing-video .glow {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  
  .glowing-video .main {
    position: relative;
    z-index: 1;
  }

  .unmute-button {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 2;
  background: rgba(0,0,0,0.6);
  border: none;
  border-radius: 50%;
  width: 3.2rem;
  height: 3.2rem;
  cursor: pointer;
  color: white;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}

.unmute-button:hover {
  opacity: 1;
}

.unmute-button span {
  position: relative;
  top: 1.5px;
}

.caption-link {
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 14px;
  padding: 4px;
  border-radius: 2px;
  z-index: 3;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}

.caption-link:hover {
  background: rgba(255, 255, 255, 0.75);
  color: #222222;
}
  </style>